export default "__VITE_ASSET__CFdcDHrD__"